export const environment = {
  isProduction: false,
  //firebase
  firebaseConfig: {
    apiKey: 'AIzaSyCvbK52ZEuUAVSK7tQBb-UhXJdjLU11gEQ',
    authDomain: 'albionfreemarket.firebaseapp.com',
    projectId: 'albionfreemarket',
    storageBucket: 'albionfreemarket.appspot.com',
    messagingSenderId: '615549188968',
    appId: '1:615549188968:web:e5735956dd1193073774dd',
  },
  //apis
  afmApis: {
    be: {
      baseUrl: 'https://api.albionfreemarket.com/be',
      // baseUrl: 'https://devapi.albionfreemarket.com:8443/be',
      // baseUrl: 'https://api.albionfreemarket.com/be',
    },
    topItems: {
      baseUrl: 'https://api.albionfreemarket.com',
      // baseUrl: 'https://devapi.albionfreemarket.com:8443',
      // baseUrl: 'https://api.albionfreemarket.com',
    },
  },
  //albionImage
  albionImage: {
    baseUrl: 'https://render.albiononline.com/v1/item/',
    destinyBoardBaseUrl: 'https://render.albiononline.com/v1/destiny/',
  },
  // albionData
  albionDataApiUrls: {
    west: 'https://west.albion-online-data.com/api/v2/stats',
    east: 'https://east.albion-online-data.com/api/v2/stats',
    europe: 'https://europe.albion-online-data.com/api/v2/stats',
  },
  // articles
  articles: {
    client: 'https://raw.githubusercontent.com/JPCodeCraft/AlbionFreeMarketTutorials/main/metadata.json',
    server: 'assets/ssg-files/articles-metadata.json',
  },
  // dataApiUrls
  dataApiUrls: {
    usNameMappings: {
      client: 'https://raw.githubusercontent.com/JPCodeCraft/AlbionFormattedItemsParser/main/us_name_mappings.json',
      server: 'assets/ssg-files/us_name_mappings.json',
    },
    items: {
      client: 'https://raw.githubusercontent.com/JPCodeCraft/AlbionLocalization/main/processed_items.json',
      server: 'assets/ssg-files/processed_items.json',
    },
    localization: {
      client: 'https://raw.githubusercontent.com/JPCodeCraft/AlbionLocalization/main/merged_localization.json',
      server: 'assets/ssg-files/merged_localization.json',
    },
    resources: {
      client: 'https://raw.githubusercontent.com/ao-data/ao-bin-dumps/master/resources.json',
      server: 'assets/ssg-files/resources.json',
    },
    achievements: {
      client: 'https://raw.githubusercontent.com/ao-data/ao-bin-dumps/master/achievements.json',
      server: 'assets/ssg-files/achievements.json',
    },
    farmingModifiers: {
      client: 'https://raw.githubusercontent.com/ao-data/ao-bin-dumps/master/farmingmodifiers.json',
      server: 'assets/ssg-files/farmingmodifiers.json',
    },
  },
  // jsonReader
  logJsonReaderTimers: false,
  excludeItems: ['@xmlns:xsi', '@xsi:noNamespaceSchemaLocation', 'shopcategories', 'crystalleagueitem'],
};
